var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "schedule_detail", attrs: { id: _vm.id } }, [
    _c("strong", { staticClass: "txt_day" }, [_vm._v(_vm._s(_vm.dateText))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wrap_schedule" },
      _vm._l(_vm.schedules, function (schedule) {
        return _c("schedule", { attrs: { schedule: schedule, date: _vm.date } })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }